import { Box, CardMedia, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RESUME_SET_TYPE } from "utils/redux/action";

export default function ButtonChoiceResume({ icon, text, type }) {
  const dispatcher = useDispatch();
  const resume = useSelector((state) => state.resumeReducer);

  return (
    <Box
      sx={{
        opacity: resume.type === null || resume.type === type ? 1 : 0.5,
        width: { xs: "100%", md: "calc((100% - 20px)/2)" },
        padding: "20px 30px 20px 30px",
        boxSizing: "border-box",
        display: "flex",
        cursor: "pointer",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "20px",
        gap: 2,
        border: `3px solid ${
          resume.type === type
            ? "rgba(54, 114, 233, 0.10)"
            : "rgba(0, 0, 0, 0.10)"
        }`,
        boxShadow:
          resume.type === type
            ? "0px 0px 10px 5px rgba(54, 114, 233, 0.25)"
            : null,
        background: "#FFF",
      }}
      onClick={() =>
        dispatcher({
          type: RESUME_SET_TYPE,
          model: resume.type === null || resume.type !== type ? type : null,
        })
      }
    >
      <Box
        sx={{
          aspectRatio: 1,
          height: 40,
          backgroundColor: "white",
          borderRadius: 3,
          boxShadow: "2.363px 7.09px 26.259px -3.414px rgba(22, 52, 80, 0.10)",
        }}
      >
        <CardMedia component="img" src={icon} />
      </Box>
      <Typography
        variant="h5"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 600,
          pointerEvents: "none",
          userSelect: "none",
          fontSize: 16,
          textWrap: "nowrap",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
